import {request} from '../services/request';
import {backendEndpoints} from '../../api';
import {apiHelpers} from '../../utils/helpers';
import {budgetConstants} from '../constants';

const errorHandlerProps = {disableAlert: true};

const getBudgetRequests = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_BUDGET_REQUESTS,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getBudgetRequestsShort = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_BUDGET_REQUESTS_SHORT,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getBudgets = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_BUDGETS,
      query: { per_page: 100, ...query },
      successCallback: (data) => {
        successCallback?.(data);
        dispatch({ type: budgetConstants.SET_BUDGETS, data: data?.results || [] } );
      },
      errorCallback,
      errorHandlerProps
    });
  }
}

const createBudget = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      data,
      url: backendEndpoints.POST_BUDGET_CREATE,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const updateBudget = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.patch({
      dispatch,
      data,
      url: apiHelpers.getUrl(backendEndpoints.PATCH_BUDGET_UPDATE, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getBudgetRequest = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.GET_BUDGET_REQUEST, {id}),
      successCallback: (data) => {
        successCallback?.(data);
        dispatch({ type: budgetConstants.SET_BUDGET_REQUEST, data });
      },
      errorCallback,
      errorHandlerProps
    });
  }
}

const getBudgetRequestExpenses = ({id, query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.GET_BUDGET_REQUEST_EXPENSES, {id}),
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const clearBudgetRequest = () => {
  return (dispatch) => {
    dispatch({ type: budgetConstants.CLEAR_BUDGET_REQUEST });
  }
}

const addBudgetToStore = (budget) => {
  return (dispatch) => {
    dispatch({ type: budgetConstants.ADD_BUDGET_TO_STORE, data: budget });
  }
}

const updateBudgetInStore = (budget) => {
  return (dispatch) => {
    dispatch({ type: budgetConstants.UPDATE_BUDGET_IN_STORE, data: budget });
  }
}

const deleteBudgetRequest = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.delete({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.DELETE_BUDGET_REQUEST, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

// Helper function for budget request operations
const budgetRequestOperation = (endpoint, methodType = 'patch') => ({approvalId, id, data, successCallback, errorCallback} = {}) => (dispatch) => {
  request[methodType]?.({
    dispatch,
    data,
    url: apiHelpers.getUrl(endpoint, {approvalId, id}),
    successCallback: (data) => {
      successCallback?.(data);
      dispatch({ type: budgetConstants.SET_BUDGET_REQUEST, data });
    },
    errorCallback,
    errorHandlerProps
  });
};

const getBatchBudgetRequests = budgetRequestOperation(backendEndpoints.POST_BUDGET_REQUESTS_BATCH, 'post');

const updateBudgetRequest = budgetRequestOperation(backendEndpoints.PATCH_BUDGET_REQUEST_UPDATE);
const closeBudgetRequest = budgetRequestOperation(backendEndpoints.PATCH_BUDGET_REQUEST_CLOSE);
const openBudgetRequest = budgetRequestOperation(backendEndpoints.PATCH_BUDGET_REQUEST_OPEN);
const approveBudgetRequest = budgetRequestOperation(backendEndpoints.PUT_BUDGET_REQUEST_APPROVE, 'put');
const rejectBudgetRequest = budgetRequestOperation(backendEndpoints.PUT_BUDGET_REQUEST_REJECT, 'put');
const reassignBudgetRequest = budgetRequestOperation(backendEndpoints.PUT_BUDGET_REQUEST_REASSIGN, 'put');
const reopenBudgetRequestApproval = budgetRequestOperation(backendEndpoints.PATCH_BUDGET_REQUEST_REOPEN_APPROVAL, 'patch');
const submitForReviewBudgetRequest = budgetRequestOperation(backendEndpoints.PATCH_BUDGET_REQUEST_SUBMIT_FOR_REVIEW);


const approvePurchaseOrder = budgetRequestOperation(backendEndpoints.PUT_PURCHASE_ORDER_APPROVE, 'put');
const rejectPurchaseOrder = budgetRequestOperation(backendEndpoints.PUT_PURCHASE_ORDER_REJECT, 'put');
const reopenPurchaseOrderApproval = budgetRequestOperation(backendEndpoints.PATCH_PURCHASE_ORDER_REOPEN_APPROVAL, 'patch');
const reassignPurchaseOrder = budgetRequestOperation(backendEndpoints.PUT_PURCHASE_ORDER_REASSIGN, 'put');
const createPurchaseOrderStep = budgetRequestOperation(backendEndpoints.POST_PURCHASE_ORDER_CREATE_STEP, 'post');
const submitForReviewPurchaseOrder = budgetRequestOperation(backendEndpoints.PATCH_PURCHASE_ORDER_SUBMIT_FOR_REVIEW);

const deletePurchaseOrderStep = ({id, approver, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.delete({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.DELETE_PURCHASE_ORDER_DELETE_STEP, {id, approver}),
      successCallback: (data) => {
        successCallback?.(data);
        dispatch({ type: budgetConstants.SET_BUDGET_REQUEST, data });
      },
      errorCallback,
      errorHandlerProps
    });
  }
}

const updatePurchaseOrderStep = ({id, approver, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.patch({
      dispatch,
      data,
      url: apiHelpers.getUrl(backendEndpoints.PATCH_PURCHASE_ORDER_UPDATE_STEP, {id, approver}),
      successCallback: (data) => {
        successCallback?.(data);
        dispatch({ type: budgetConstants.SET_BUDGET_REQUEST, data });
      },
      errorCallback,
      errorHandlerProps
    });
  }
}

const createBudgetRequestDocument = budgetRequestOperation(backendEndpoints.POST_BUDGET_REQUEST_DOCUMENT_CREATE, 'post');

const deleteBudgetRequestDocument = ({id, documentId, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.delete({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.DELETE_BUDGET_REQUEST_DOCUMENT, {id, documentId}),
      successCallback: (data) => {
        successCallback?.(data);
        dispatch({ type: budgetConstants.SET_BUDGET_REQUEST, data });
      },
      errorCallback,
      errorHandlerProps
    });
  }
}

const downloadBudgetRequestDocument = ({id, documentId, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.GET_BUDGET_REQUEST_DOCUMENT_ATTACHMENT, {id, documentId}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const exportBudgetRequests = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_BUDGET_REQUESTS_EXPORT,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

export const budgetActions = {
  createBudget,
  getBudgets,
  updateBudget,
  clearBudgetRequest,
  addBudgetToStore,
  updateBudgetInStore,

  getBudgetRequests,
  getBudgetRequestsShort,
  getBudgetRequest,
  getBudgetRequestExpenses,
  getBatchBudgetRequests,
  deleteBudgetRequest,
  exportBudgetRequests,
  createBudgetRequestDocument,
  deleteBudgetRequestDocument,
  downloadBudgetRequestDocument,
  closeBudgetRequest,
  openBudgetRequest,
  updateBudgetRequest,
  approveBudgetRequest,
  rejectBudgetRequest,
  reassignBudgetRequest,
  reopenBudgetRequestApproval,
  submitForReviewBudgetRequest,

  approvePurchaseOrder,
  rejectPurchaseOrder,
  reassignPurchaseOrder,
  reopenPurchaseOrderApproval,
  createPurchaseOrderStep,
  deletePurchaseOrderStep,
  updatePurchaseOrderStep,
  submitForReviewPurchaseOrder,
};
